import { VApp } from 'vuetify/lib/components/VApp';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"itw-app"},[_c('itw-snackbar',{attrs:{"color":_vm.snackbar.color,"text":_vm.snackbar.text},model:{value:(_vm.snackbar.display),callback:function ($$v) {_vm.$set(_vm.snackbar, "display", $$v)},expression:"snackbar.display"}}),(_vm.loading)?_c(VRow,{staticClass:"full-width fill-height",attrs:{"align":"center","justify":"center"}},[_c('itw-loader')],1):[(_vm.forbidden)?_c('itw-forbidden',[_vm._v("Forbidden")]):_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }